import React from 'react';

const NotFound = () => {
  return (
    <div className="container mainContainer">
      <h1 className="title">Erro: 404</h1>
      <p>Pagina não Encontrada!</p>
    </div>
  );
};

export default NotFound;
